module.exports = __webpack_public_path__ + "static/media/broadcast.671022a9.svg";